import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

export default class OcrRightSidebar extends React.Component {
    public static propTypes = {
        options: PropTypes.object,
    };

    public static initDom = (DOMNode) => {
        ReactDOM.render(<OcrRightSidebar/>, DOMNode);
    };

    public render() {
        return (
            <div id='ocr-right-sidebar'>
            </div>
        );
    }
}
